import { routes, type RegistrationStatus } from '@ipc/shared'
import { requestForm } from '~/api/client'

/** One multipart upload: the capture token and exactly the frames the profile asked for (never JSON, never stored). */
export async function uploadFrames(token: string, frames: Blob[]): Promise<RegistrationStatus> {
  const form = new FormData()
  form.append('token', token)
  frames.forEach((frame, i) =>
    form.append('frames', frame, `frame-${i + 1}.${frame.type === 'image/png' ? 'png' : 'jpg'}`)
  )
  return (await requestForm(routes.captureUpload, 'captureUpload', form)) as RegistrationStatus
}
